import { questionGenerator } from '@/data/generators/questionGenerator';
import { QuizAnswer, QuizAnswerTypeEnum } from '@/models/Answer';
import { QuestionTypeEnum, QuizQuestion } from '@/models/Question';

export function quizQuestionGenerator(
  question?: Partial<QuizQuestion>,
): QuizQuestion {
  return {
    answerType: QuizAnswerTypeEnum.TEXT,
    quizAnswers: [],
    ...questionGenerator(question),
    ...question,
    type: QuestionTypeEnum.QUIZ,
  };
}

export function quizAnswerGenerator(answer?: Partial<QuizAnswer>): QuizAnswer {
  return {
    id: 1,
    text: 'Opção A',
    isCorrect: false,
    ...answer,
  };
}
